/** Private tasks (personal to-dos merged into Tasks): badge, due/reminder fields and the shared "today in the UK" helper. */
import { DateTime } from 'luxon';
import clsx from 'clsx';
import { Lock } from 'lucide-react';
import { TODO_TZ } from '@tradeoutlet/shared';
import { Input } from '@/components/ui';

export const ukToday = () => DateTime.now().setZone(TODO_TZ).toISODate()!;

export const PRIVATE_HINT = 'Private: only you can see this task. Managers and admins can’t see it.';

/** Neutral pill (no brand yellow on light surfaces): lock icon + "Private". */
export function PrivateBadge({ className }: { className?: string }) {
  return (
    <span data-testid="private-badge" title={PRIVATE_HINT} aria-label="Private task, only you can see it"
      className={clsx('inline-flex shrink-0 items-center gap-1 rounded bg-slate-100 px-1.5 py-0.5 text-[11px] font-medium text-slate-700 dark:bg-slate-800 dark:text-slate-200', className)}>
      <Lock className="h-3 w-3" aria-hidden />Private
    </span>
  );
}

export interface PrivateDue { due_date: string | null; due_time: string | null; reminder_minutes: number | null }

/** Due date and optional time (the old to-do fields; the time needs a date). Reminders are the task's one "Remind me" control (TaskReminder). */
export function PrivateDueFields({ value, onChange, disabled }: { value: PrivateDue; onChange: (patch: Partial<PrivateDue>) => void; disabled?: boolean }) {
  return (
    <div className="grid gap-2 sm:grid-cols-2" data-testid="private-due-fields">
      <label className="text-xs text-slate-500">Due date
        <Input type="date" disabled={disabled} value={value.due_date ?? ''} onChange={e => onChange(e.target.value ? { due_date: e.target.value } : { due_date: null, due_time: null })} />
      </label>
      <label className="text-xs text-slate-500">Time
        <Input type="time" disabled={disabled || !value.due_date} value={value.due_time ?? ''} onChange={e => onChange({ due_time: e.target.value || null })} />
      </label>
    </div>
  );
}
